export default [
  'vessels',
  'vessel-types',
  'vessel-subtypes',
  'vessel-prefixes',
  'vessel-situations',
  'people',
  'parties',
  'widget-types',
  'roles',
  'fuel-grades',
  'fuel-grades-with-prices',
  'cp-forms',
  'units',
  'market-indexes',
  'market-index-types',
  'misc-descriptions',
  'terms',
  'ports',
  'job-types',
  'departments',
  'party-company-types',
  'vessel-consumption-types',
  'organizations',
  'report-types',
  'logs-statuses',
  'logs-types',
  'job-log-types',
  'job-log-statuses',
  'airport-types',
  'countries',
  'classification-societies',
  'airlines',
  'evaluation-criteria-categories',
  'value-types',
  'vessel-document-categories',
  'form-field-types',
  'port-areas',
  'port-types',
  'beacon-pages-suggestions',
  'aggregation-types',
  'crew-matrix-rule-types',
  'crew-ranks',
  'store-groups',
  'purchasing-units'
];
